import Menu from "./Menu";

export default function Layout({ children }) {
  return (
    <main>
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <Menu />
            {children}
          </div>
        </div>
      </div>
      <footer className="footer">
        <div className="container">
          <div className="col">
            <p>
                &copy; LPI CONSEIL 2021
            </p>
          </div>
        </div>
      </footer>
    </main>
  );
}
